import InfoField from './InfoField';
export default InfoField;
export { default as InfoField } from './InfoField';